import { render, staticRenderFns } from "./AvailableOtherLabours.vue?vue&type=template&id=79f547e1&scoped=true"
import script from "./AvailableOtherLabours.vue?vue&type=script&lang=js"
export * from "./AvailableOtherLabours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f547e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f547e1')) {
      api.createRecord('79f547e1', component.options)
    } else {
      api.reload('79f547e1', component.options)
    }
    module.hot.accept("./AvailableOtherLabours.vue?vue&type=template&id=79f547e1&scoped=true", function () {
      api.rerender('79f547e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailableOtherLabours.vue"
export default component.exports